export const faqData = [
  {
    id: 1,
    question: "What is personal loan debt consolidation?",
    answer:
      "It involves combining multiple personal loans into a single loan with a lower interest rate and better repayment terms.",
  },
  {
    id: 2,
    question: "How can I calculate my EMI for a consolidated loan?",
    answer:
      "Use Minemi’s Personal Loan Debt Consolidation Calculator by entering your loan amount, interest rate, and tenure for accurate estimates.",
  },
  {
    id: 3,
    question: "Can consolidating personal loans save money?",
    answer:
      "Yes, consolidating high-interest loans into a lower-interest loan reduces your monthly payments and total interest paid.",
  },
  {
    id: 4,
    question: "What documents are required for consolidation?",
    answer:
      "Typical documents include proof of income, ID proof, and statements for existing personal loans.",
  },
  {
    id: 5,
    question:
      "Can I consolidate personal loans from different apps and lenders?",
    answer:
      "Yes, you can consolidate loans from multiple lenders, provided the new lender approves the consolidation loan.",
  },
  {
    id: 6,
    question: "Will debt consolidation hurt my credit score?",
    answer:
      "No, it can improve your credit score over time if you make timely payments. However, initial inquiries may cause a slight dip.",
  },
  {
    id: 7,
    question: "What is the ideal interest rate for a consolidated loan?",
    answer:
      "Aim for an interest rate significantly lower than your existing loans, ideally under 12%-15% in India.",
  },
];
